import { RootState } from "../../../utils/types/root-state";

export const getCurrentIngredientState = (state: RootState) => state.currentIngredient;
